export class CreateTargetEspecificationsDTO {
    startDate: Date;
    finishDate: Date;
    goal: number;
    targetId: string;
    status: boolean;

    constructor() {
    }
}